export default __webpack_public_path__ + "static/media/rt-header-logo1.8144c78b.png";